import { Image } from "@/Components/common/Image"
import { Layout } from "@/Layout"
import { BSelect } from "@/NewComponents/BSelect"
import { Payments } from "../Home/Payments"
import { AssetLinkBox } from "../Home/HomeAssets/AssetLinkBox"
import "./style.css"
import { Currencies } from "@/types"
import { ApiData } from "@usher/pe-client-front-end-lib"
import { useEffect, useState } from "react"
import { Container } from "@/Layout/Container"
import { Msg } from "@/Components/Msg"

const FIAT_OPTION = { label: "EUR", value: "EUR" }
export const Rates = () => {
  const [filteredRates, setFilteredRates] = useState([])

  useEffect(() => {
    ApiData.getCurrenciesExchange().then((data) => {
      const rates = Object.entries(data?.crypto_prices ?? {}).map(([symbol, rate]) => ({
        symbol,
        rate,
      }))

      setFilteredRates(rates)
    })
  }, [])

  return (
    <Layout>
      <main className="rates-main">
        <section className="assets">
          <Container>
            <div className="assets__box">
              <div className="assets__top">
                <h2 className="h2 assets__h2">
                  <Msg id="footer2" />
                </h2>
                <h2 className="h2 assets__h2-mob">
                  <Msg id="how1" />
                </h2>
              </div>
              <div className="assets__info">
                <div className="assets-form">
                  <BSelect
                    buttonStyle={{ minWidth: 100 }}
                    options={[FIAT_OPTION]}
                    value={FIAT_OPTION}
                  />
                </div>
                <div className="assets__block">
                  <AssetLinkBox currency={Currencies.BTC} rates={filteredRates} />
                  <AssetLinkBox currency={Currencies.ETH} rates={filteredRates} />
                </div>
              </div>
              <div className="assets__info-middle">
                <AssetLinkBox currency={Currencies.LTC} rates={filteredRates} />
                <AssetLinkBox currency={Currencies.USDT_ERC20} rates={filteredRates} />
                <AssetLinkBox currency={Currencies.USDT_TRC20} rates={filteredRates} />
              </div>
              <div className={`assets__info-middle`}>
                <AssetLinkBox rates={filteredRates} currency={Currencies.USDC_ERC20} />

                <AssetLinkBox rates={filteredRates} currency={Currencies.USDC_BEP20} />
                <AssetLinkBox rates={filteredRates} currency={Currencies.DASH} />
              </div>
              <div className={`assets__info-middle`}>
                <AssetLinkBox rates={filteredRates} currency={Currencies.ICP} />
                <AssetLinkBox rates={filteredRates} currency={Currencies.BNB} />
              </div>
            </div>
          </Container>
        </section>

        <section className="min">
          <div className="container">
            <div className="min__wrap">
              <h2 className="h2 min__title">
                <Msg id="rates1" /> <Msg id="commission" />
              </h2>
              <div className="min__box">
                <div className="min__box-top">
                  <ul className="min-list">
                    <li className="min-list__item">
                      <div className="min-list__box-img">
                        <Image src="min-1.png" />
                      </div>
                      <h3 className="min-list__title">
                        <Msg id="rates_title1" />
                      </h3>
                      <p className="min-list__text">
                        <Msg id="rates3" />
                      </p>
                    </li>
                    <li className="min-list__item">
                      <div className="min-list__box-img">
                        <Image src="min-2.png" />
                      </div>
                      <h3 className="min-list__title">
                        <Msg id="rates_title2" />
                      </h3>
                      <p className="min-list__text">
                        <Msg id="rates4" />
                      </p>
                    </li>
                    <li className="min-list__item">
                      <div className="min-list__box-img">
                        <Image src="min-3.png" />
                      </div>
                      <h3 className="min-list__title">
                        <Msg id="rates_title3" />
                      </h3>
                      <p className="min-list__text">
                        <Msg id="rates5" />
                      </p>
                    </li>
                  </ul>
                </div>
                <div className="min__box-bottom">
                  <ul className="min-list">
                    <li className="min-list__item min-list__item-bot">
                      <div className=" min-list__box-marg">
                        <Image src="min-4.png" />
                      </div>
                      <h3 className="min-list__title">
                        <Msg id="rates_title4" />
                      </h3>
                      <p className="min-list__text min-list__text-bot">
                        <Msg id="rates6" />
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>
        <Payments isLight />
      </main>
    </Layout>
  )
}
